import React, { useState, useEffect, useRef } from 'react';
import { useApp } from '../../../context/AppContext';
import { useSimulado } from '../../../context/SimuladoContext';
import { getSimuladoRules } from '../../../context/simuladoRules';
import { Link, useNavigate } from 'react-router-dom';
// import './statistics_content.css';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import Card from '../../../components/base/Card/Card';
import Sidebar from '../../../components/base/Sidebar/Sidebar';
import InfoCard from '../../../components/base/InfoCard/InfoCard';
// import SwotGrid from './SwotGrid';

// Add some styles for the local prova text display
const localProvaTextStyle = {
  padding: '20px 30px',
  backgroundColor: 'white',
  borderRadius: '8px',
  maxWidth: '90%',
  margin: '0 auto',
  textAlign: 'center',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  fontSize: '16px',
  lineHeight: '1.5'
};

function StatisticsContent() {
  const { user } = useApp();
  const navigate = useNavigate();
  const [performance, setPerformance] = useState(null);
  const [simuladoDate, setSimuladoDate] = useState('');
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState('');
  const userID = user?.ID_usuario;
  const { simulado, provas, updateSimuladoData, selectSimulado } = useSimulado();
  const hasProva = (abbr) => provas.some(p => p.prova_abbr === abbr);
  const selectedSimuladoID = simulado.id;
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [nullQuestions, setNullQuestions] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [cartaoRespostaUrl, setCartaoRespostaUrl] = useState('');
  const [cartaoRespostaUrls, setCartaoRespostaUrls] = useState([]);
  const [currentCartaoIndex, setCurrentCartaoIndex] = useState(0);
  const [cartaoImageError, setCartaoImageError] = useState(false);

  const [localProvaUrl, setLocalProvaUrl] = useState('');
  const [localProvaIsUrl, setLocalProvaIsUrl] = useState(true);
  const [showStagesPopup, setShowStagesPopup] = useState(false);
  const [popupType, setPopupType] = useState(''); // 'cartao' or 'local'
  const [gabaritoFile, setGabaritoFile] = useState(false);
  const [showInscricaoPopup, setShowInscricaoPopup] = useState(false);
  const [inscritoSimulado, setInscritoSimulado] = useState(false);
  const [reportStatusLabels, setReportStatusLabels] = useState([]);


  useEffect(() => {
    fetch('https://rvensino.com.br/get.php?action=get_report_status')
      .then(r => r.json())
      .then(data => setReportStatusLabels(Array.isArray(data) ? data : []))
      .catch(err => console.error('Erro ao buscar report_status:', err));
  }, []);

  const popupRef = useRef(null);
  const stagesPopupRef = useRef(null);
  // Adicionar useRef para o popup de inscrição
  const inscricaoPopupRef = useRef(null);

// Add new useEffect to handle simulado selection
  useEffect(() => {
    const fetchAndSelectSimulado = async () => {
      if (!userID) return;

      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=get_simulados_by_aluno&ID_aluno=${userID}`);
        const simuladoData = await response.json();

        if (!simuladoData || !simuladoData.simulado_IDs || simuladoData.simulado_IDs.length === 0) {
          console.error('Nenhum simulado encontrado para o aluno');
          setLoading(false);
          return;
        }

        const simuladosData = simuladoData.simulado_IDs.map((id, index) => ({
          id,
          date: simuladoData.simulado_datas[index],
        }));

        const mostRecent = simuladosData[simuladosData.length - 1];
        const sessionInitialized = sessionStorage.getItem('simuladoSessionInitialized');

        if (!sessionInitialized) {
          // fresh page load or hard refresh — always pick the most recent
          selectSimulado(mostRecent.id);
          sessionStorage.setItem('simuladoSessionInitialized', 'true');
        } else if (!selectedSimuladoID) {
          selectSimulado(mostRecent.id);
        }
      } catch (error) {
        console.error('Erro ao buscar lista de simulados:', error);
        setLoading(false);
      }
    };

    fetchAndSelectSimulado();
  }, [userID]); // eslint-disable-line react-hooks/exhaustive-deps

  // Check if a grade value is effectively "not available"
  // -1 means not yet graded
  // 0.000001 is a sentinel value used for subjects that don't apply to this simulado type (e.g., Redação in pre-simulado)
  const isGradeUnavailable = (value) => {
    return value === undefined || value === null || value === -1 || value === 0.000001;
  };

  const roundToOneDecimal = (number) => {
    return number && !isGradeUnavailable(number) ? Number(number).toFixed(1).replace('.', ',') : '-';
  };

  const isUnavailable = (info) => info === '-';

  // Helper to parse path_cartao_resposta which can be:
  // 1. A plain URL string: "https://rvensino.com.br/path/to/image.png"
  // 2. A URL with an embedded JSON array: "https://rvensino.com.br/["img1.png","img2.png"]"
  const parseCartaoRespostaPath = (rawPath) => {
    const baseUrl = 'https://rvensino.com.br/';

    // Helper to fix REDACAO path: replace /REDACAO/ with /Redação/
    const fixRedacaoPath = (path) => path.replace(/\/REDACAO\//g, '/Redação/');

    // Try to extract a JSON array from the URL
    // The format is: https://rvensino.com.br/["path1","path2",...]
    const arrayMatch = rawPath.match(/^https:\/\/rvensino\.com\.br\/(\[.*\])$/);
    if (arrayMatch) {
      try {
        const parsedArray = JSON.parse(arrayMatch[1]);
        if (Array.isArray(parsedArray) && parsedArray.length > 0) {
          // Map each relative path to a full URL, fixing REDACAO paths
          const fullUrls = parsedArray.map(p => baseUrl + fixRedacaoPath(p));
          return { isArray: true, urls: fullUrls };
        }
      } catch (e) {
        console.error('Erro ao parsear array do path_cartao_resposta:', e);
      }
    }

    // Fallback: treat as a single URL, fixing REDACAO path if present
    return { isArray: false, urls: [fixRedacaoPath(rawPath)] };
  };

  useEffect(() => {
    const fetchCartaoResposta = async () => {
      if (!userID || !selectedSimuladoID) return;

      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=getCartaoResposta&ID_usuario=${userID}&ID_prova=${selectedSimuladoID}`);
        const data = await response.json();

        if (data.length > 0 && data[0].path_cartao_resposta) {
          const rawPath = data[0].path_cartao_resposta;
          console.log('rawPath:', rawPath);
          const parsed = parseCartaoRespostaPath(rawPath);
          console.log('parsed URLs:', parsed.urls);
          setCartaoRespostaUrls(parsed.urls);
          setCartaoRespostaUrl(parsed.urls[0]);
          setCurrentCartaoIndex(0);

        }
        else {
          setCartaoRespostaUrl("");
          setCartaoRespostaUrls([]);
        }
      } catch (error) {
        console.error('Erro ao buscar o cartão resposta:', error);
      }
    };

    fetchCartaoResposta();
  }, [userID, selectedSimuladoID]);


  useEffect(() => {
    const fetchLocalProva = async () => {
      if (!userID || !selectedSimuladoID) return;

      try {
        
        const response = await fetch(`https://rvensino.com.br/get.php?action=get_local_prova&user_id=${userID}&exam_id=${selectedSimuladoID}`);
        const data = await response.text();

        // Local de prova is always text in this format, never an image URL
        if (data) {
          setLocalProvaUrl(data);
          setLocalProvaIsUrl(true); // Always set to false since it's always text
        } else {
          setLocalProvaUrl("");
          setLocalProvaIsUrl(false); 
        }
      } catch (error) {
        console.error('Erro ao buscar o local de prova:', error);
      }
    };

    fetchLocalProva();
  }, [userID, selectedSimuladoID]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
      if (stagesPopupRef.current && !stagesPopupRef.current.contains(event.target)) {
        setShowStagesPopup(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (!userID || !selectedSimuladoID) return;

      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=dashboard&user_id=${userID}&exam_id=${selectedSimuladoID}`);
        const data = await response.json();
        
        // console.log(data)
        
        // isso aqui deveria estar vindo do context
        const storedUserName = localStorage.getItem('userName');

        if (storedUserName) {
          const firstName = storedUserName.split(' ')[0];
          setUserName(firstName);
        }

        if (data) {
          updateSimuladoData(data);

          // console.log(`Status do simulado: ${data.exam_status}`);

          setSimuladoDate(data.exam_date);
          if (data.exam_date) localStorage.setItem('simuladoDate', data.exam_date);
          setGabaritoFile(data.gabarito_file);


          // Atualiza os dados de questões diretamente da resposta
          setTotalQuestions(data.n_total);
          setNullQuestions(data.n_anuladas);

          // Atualiza o estado de performance para usar os novos dados
          setPerformance({
            Notas: {
              Media_sem_redacao: data.grade_without_essay,
              Media_com_redacao: data.grade_with_essay,
              Ciencias_Humanas: data.grade_humanas,
              Linguagens: data.grade_linguagens,
              Ciencias_Natureza: data.grade_natureza,
              Matematica: data.grade_matematica,
              Redacao: data.grade_redacao
            },
            Acertos: data.n_acertos,
            Erros: data.n_erros,
            Nulas: data.n_anuladas,
            TotalQuestoes: data.n_total,
            Classificacao_geral: data.overall_rating,
            Classificacao_grupo: data.class_rating
          });
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error('Erro ao buscar os dados do dashboard:', error);
      }
    };

    fetchDashboardData();
  }, [userID, selectedSimuladoID]);

  const handleOpenPopup = (type) => {
    setPopupType(type);
    setShowPopup(true);
  };

  const handleOpenGabarito = () => {
    // Replace this URL with your actual PDF URL when ready
    window.open(`https://rvensino.com.br/${gabaritoFile}`, '_blank');
  };

  if (loading) {
    return <div className='loading'>...</div>;
  }

  if (!performance) {
    return (
      <div className='page-container'>
        <div className='empty dashboard'>Suas performances de simulados aparecerão aqui</div>
      </div>
    );
  }

  const { Notas, Acertos, Classificacao_geral, Classificacao_grupo } = performance;
  const {
    showRanking: rankingEnable,
    showExams: examsEnable,
    showLocalProva: localProvaEnable,
    showCartao: cartaoRespostaEnable,
    showGabarito: gabaritoEnable,
    getMarchState,
  } = getSimuladoRules(simulado.status);

  return (
    <div>
      <div className={`content-container${showPopup || showStagesPopup || showInscricaoPopup ? ' blur' : ''}`}>
        <div className='content'>
          <div className='exam-link-container'>
            <p className="result-text"> Oi, {userName}! Confira aqui seus resultados: </p>
            
            <div className='simulado-info'>
              <span className="progress-text">Etapa: </span>
              <div className="simulado-progress" onClick={() => setShowStagesPopup(true)} style={{ cursor: 'pointer' }}>
                <div className="progress-bar">
                  {/* <div className={`progress-fill stage-${status}`}></div> */}
                  <div className={`progress-fill stage-${simulado.status}`}></div>
                </div>
                <div className="progress-stages">
                  <span>1</span>
                  <span>2</span>
                  <span>3</span>
                  <span>4</span>
                  <span>5</span>
                  <span>6</span>
                  <span>7</span>
                </div>
              </div>

              <div className='exam dashboard-link'>
                <Link to="/historico" className="no-link-style"> Simulado realizado em {simuladoDate} </Link>
              </div>
            </div>
          </div>
          
          <div className='card-container'>
            {!rankingEnable ? (
              <div className='unavailable'>
                <div className='welcome-card unavailable card-inactive'>
                  <p className='welcome-message'>
                    Classificação geral: <span className='placing'>-</span>
                    <br />
                    Classificação do grupo: <span className='placing'>-</span>
                  </p>
                  <LeaderboardOutlinedIcon className='icon card' style={{ fontSize: 85 }} />
                </div>
              </div>
            ) : (
              <Link to="/ranking" className='no-link-style'>
                <div className={`welcome-card ${isUnavailable(String(Classificacao_geral)) && isUnavailable(String(Classificacao_grupo)) ? 'unavailable card-inactive' : ''}`}>
                  <p className='welcome-message'>
                    Classificação geral: <span className='placing'>{Classificacao_geral ? `${Classificacao_geral}º` : '-'}</span>
                    <br />
                    Classificação do grupo: <span className='placing'>{Classificacao_grupo ? `${Classificacao_grupo}º` : '-'}</span>
                  </p>
                  <LeaderboardOutlinedIcon className='icon card' style={{ fontSize: 85 }} />
                </div>
              </Link>
            )}
            <InfoCard title="Média sem redação" info={roundToOneDecimal(performance?.Notas?.Media_sem_redacao)} />
            <InfoCard title="Média com redação" info={roundToOneDecimal(performance?.Notas?.Media_com_redacao)} />
          </div>

          <div className='card-container'>
            {/* Card 1: Ciências Humanas e suas Tecnologias */}
            {!examsEnable || !hasProva('CH') ? (
              <div className='unavailable'>
                <Card unavailable title="Ciências Humanas e suas Tecnologias" info="-" icon="groups" />
              </div>
            ) : (
              <Link to="/detalhes" state={{ expandedExam: 'CH' }} className="no-link-style">
                <Card
                  title="Ciências Humanas e suas Tecnologias"
                  info={isGradeUnavailable(performance?.Notas?.Ciencias_Humanas) ? '-' : roundToOneDecimal(performance?.Notas?.Ciencias_Humanas)}
                  icon="groups"
                  exam={true}
                />
              </Link>
            )}

            {/* Card 2: Linguagens, Códigos e suas Tecnologias */}
            {!examsEnable || !hasProva('LC') ? (
              <div className='unavailable'>
                <Card unavailable title="Linguagens, Códigos e suas Tecnologias" info="-" icon="chat" />
              </div>
            ) : (
              <Link to="/detalhes" state={{ expandedExam: 'LC' }} className="no-link-style">
                <Card
                  title="Linguagens, Códigos e suas Tecnologias"
                  info={isGradeUnavailable(performance?.Notas?.Linguagens) ? '-' : roundToOneDecimal(performance?.Notas?.Linguagens)}
                  icon="chat"
                  exam={true}
                />
              </Link>
            )}

            {/* Card 3: Ciências da Natureza e suas Tecnologias */}
            {!examsEnable || !hasProva('CN') ? (
              <div className='unavailable'>
                <Card unavailable title="Ciências da Natureza e suas Tecnologias" info="-" icon="bio" />
              </div>
            ) : (
              <Link 
                to="/detalhes" 
                state={{ expandedExam: 'CN' }} 
                className="no-link-style"
              >
                <Card 
                  title="Ciências da Natureza e suas Tecnologias" 
                  info={isGradeUnavailable(performance?.Notas?.Ciencias_Natureza) ? '-' : roundToOneDecimal(performance?.Notas?.Ciencias_Natureza)} 
                  icon="bio"
                  exam={true}
                />
              </Link>
            )}

            {/* Card 4: Matemática e suas Tecnologias */}
            {!examsEnable || !hasProva('MT') ? (
              <div className='unavailable'>
                <Card unavailable title="Matemática e suas Tecnologias" info="-" icon="functions" />
              </div>
            ) : (
              <Link 
                to="/detalhes" 
                state={{ expandedExam: 'MT' }} 
                className="no-link-style"
              >
                <Card 
                  title="Matemática e suas Tecnologias" 
                  info={isGradeUnavailable(performance?.Notas?.Matematica) ? '-' : roundToOneDecimal(performance?.Notas?.Matematica)} 
                  icon="functions"
                  exam={true}
                />
              </Link>
            )}

            {/* Card 5: Redação */}
            {!examsEnable || !hasProva('RD') ? (
              <div className='unavailable'>
                <Card unavailable title="Redação" info="-" icon="create" />
              </div>
            ) : (
              <Link to="/detalhes" state={{ expandedExam: 'RD' }} className="no-link-style">
                <Card
                  title="Redação"
                  info={isGradeUnavailable(performance?.Notas?.Redacao) ? '-' : roundToOneDecimal(performance?.Notas?.Redacao)}
                  icon="create"
                  exam={true}
                />
              </Link>
            )}
          </div>
          
          {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <SwotGrid />
          </div> */}

          <div className='summary-container'>
            <div className='summary'>
              {/* Acertos */}
              <div className='info'>
                <p className='card-info' style={{ color: '#5faa5f' }}>
                  {cartaoRespostaUrl === '' 
                    ? '-' 
                    : performance?.Acertos}
                </p>
                <p className='card-title'>acertos</p>
              </div>

              {/* Erros */}
              <div className='info'>
                <p className='card-info' style={{ color: '#ff6767' }}>
                  {cartaoRespostaUrl === '' 
                    ? '-' 
                    : performance?.Erros}
                </p>
                <p className='card-title'>erros</p>
              </div>

              {/* Anuladas */}
              <div className='info'>
                <p className='card-info' style={{ color: '#909090' }}>
                  {cartaoRespostaUrl === '' 
                    ? '-' 
                    : performance?.Nulas}
                </p>
                <p className='card-title'>anuladas</p>
              </div>

              {/* Total de questões */}
              <div className='info'>
                <p className='card-info'>
                  {cartaoRespostaUrl === '' 
                    ? '-' 
                    : performance?.TotalQuestoes}
                </p>
                <p className='card-title'>total</p>
              </div>

              {/* Local de Prova Button */}
              <div className='info prova'>
                <button
                  className={`open-popup-button-statistics ${!localProvaEnable ? 'disabled' : ''}`}
                  onClick={() => navigate('/local-de-prova')}
                  disabled={!localProvaEnable}
                >
                  local de prova
                </button>
              </div>

              {/* Cartão Resposta Button */}
              <div className='info'>
                <button
                  className={`open-popup-button-statistics ${!cartaoRespostaEnable ? 'disabled' : ''}`}
                  onClick={() => cartaoRespostaEnable ? handleOpenPopup('cartao') : null}
                  disabled={!cartaoRespostaEnable}
                >
                  cartão-resposta
                </button>
              </div>

              {/* Gabarito Completo Button */}
              <div className='info pdf'>
                <button
                  className={`open-popup-button-statistics ${!gabaritoEnable ? 'disabled' : ''}`}
                  onClick={handleOpenGabarito}
                  disabled={!gabaritoEnable}
                  >
                  gabarito completo
                </button>
              </div> 


              
            </div>
          </div>
        </div>
      </div>

      {/* Popup for both Cartão Resposta and Local de Prova */}
      <div>
        {showPopup && (
          <div className={`popup-overlay-statistics ${popupType}`} ref={popupRef} onClick={() => setShowPopup(false)}>
            {popupType === 'cartao' ? (
              <div className="cartao-resposta-container" onClick={(e) => e.stopPropagation()}>

              <div className='close-button-container cartao'>
                <button
                  className='close-popup-statistics'
                  onClick={() => setShowPopup(false)}
                  >
                  X
                </button>
              </div>

              <div className="cartao-carousel-wrapper">
                {cartaoRespostaUrls.length > 1 && (
                  <button
                    className="cartao-carousel-arrow cartao-carousel-arrow-left"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCartaoImageError(false);
                      setCurrentCartaoIndex(prev => {
                        const newIndex = prev === 0 ? cartaoRespostaUrls.length - 1 : prev - 1;
                        setCartaoRespostaUrl(cartaoRespostaUrls[newIndex]);
                        return newIndex;
                      });
                    }}
                  >
                    &#8249;
                  </button>
                )}

                {cartaoImageError ? (
                  <div className="cartao-image-error">
                    <p>Imagem não disponível</p>
                  </div>
                ) : (
                  <img
                    src={cartaoRespostaUrl}
                    alt="Cartão Resposta"
                    className='popup-image-statistics'
                    onError={() => {
                      console.error('Erro ao carregar imagem:', cartaoRespostaUrl);
                      setCartaoImageError(true);
                    }}
                  />
                )}

                {cartaoRespostaUrls.length > 1 && (
                  <button
                    className="cartao-carousel-arrow cartao-carousel-arrow-right"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCartaoImageError(false);
                      setCurrentCartaoIndex(prev => {
                        const newIndex = prev === cartaoRespostaUrls.length - 1 ? 0 : prev + 1;
                        setCartaoRespostaUrl(cartaoRespostaUrls[newIndex]);
                        return newIndex;
                      });
                    }}
                  >
                    &#8250;
                  </button>
                )}
              </div>

              {cartaoRespostaUrls.length > 1 && (
                <div className="cartao-carousel-dots">
                  {cartaoRespostaUrls.map((_, idx) => (
                    <span
                      key={idx}
                      className={`cartao-carousel-dot ${idx === currentCartaoIndex ? 'active' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCartaoImageError(false);
                        setCurrentCartaoIndex(idx);
                        setCartaoRespostaUrl(cartaoRespostaUrls[idx]);
                      }}
                    />
                  ))}
                </div>
              )}


              </div>

            ) : (
              <div className="local-prova-text" style={localProvaTextStyle}>

                <div className='close-button-container'>
                  <button
                    className='close-popup-statistics'
                    onClick={() => setShowPopup(false)}
                    >
                    X
                </button>
                </div>

                <h3 style={{marginBottom: '15px', color: '#333', fontSize: '22px'}}>Local de Prova</h3>
                <p style={{fontSize: '18px'}}>{localProvaUrl}</p>


              </div>
            )}
            
          </div>
        )}
      </div>




{/* Stages Popup */}
<div>
  {showStagesPopup && (
    <div className="popup-overlay-statistics etapas" ref={stagesPopupRef} onClick={() => setShowStagesPopup(false)}>
      <div className="popup-content-stages" onClick={(e) => e.stopPropagation()}>
        <div className='stages-text'> 
          
          <div className='close-button-container etapa'> 
            <button
              className="close-popup-statistics stages"
              onClick={() => setShowStagesPopup(false)}
            >
              X
            </button>
          </div>

          <h3 className='stages-title'>Etapas do Simulado</h3>
          
          <div className="stages-timeline-container">

        <div className="stages-maintext-container">



          <div className="stages-stage">
            <div className={`stages-circle ${getMarchState(1)}`}>1</div>
            <div className="stages-pole-beginning"></div>
          </div>




          {/* Circles 1–6: driven by report_status data */}
          {reportStatusLabels.filter(s => s.status > 1).map(s => (
            <div className="stages-stage" key={s.status}>
              <div className={`stages-maintext ${getMarchState(s.status) === 'next' ? 'bold-text' : ''}`}>{s.achieved_milestone}</div>
              <div className={`stages-circle ${getMarchState(s.status)}`}>{s.status}</div>
              <div className="stages-pole"></div>
            </div>
          ))}





        </div>

        <div className="stages-middle-line"></div>

        <div className="stages-subtext-container">
          {/* First slot is empty (before circle 0) */}
          <div className="stages-subtext"></div>
          {/* Subtexts: description of status 1 through 6 (between circles) */}
          {reportStatusLabels.filter(s => s.status >= 1 && s.status < 7).map(s => (
            <div key={s.status} className={`stages-subtext ${s.status === simulado.status ? 'bold-text' : 'normal-text'}`}>
              {s.description}
            </div>
          ))}
        </div>

      </div>




          
        </div>
      </div>
    </div>
  )}
</div>







      {/* Popup de inscrição do próximo simulado */}
      <div>
        {showInscricaoPopup && (
          <div className="popup-overlay-statistics etapas">
            <div className="popup-content-stages" ref={inscricaoPopupRef}>
              <div className='stages-text'>
                <h2 style={{marginBottom: '10px'}}>Próximo Simulado</h2>
                <div className="inscricao-info">
                  <p><b>Nome:</b> Simulado Nacional RV</p>
                  <p><b>Data:</b> 30/06/2024</p>
                  <p><b>Horário:</b> 13:00</p>
                  <p><b>Regras:</b> Compareça com documento oficial, caneta preta, e chegue com 30 minutos de antecedência.</p>
                </div>
                <button
                  className={`inscricao-simulado-btn${inscritoSimulado ? ' inscrito' : ''}`}
                  onClick={() => { setInscritoSimulado(true); setShowInscricaoPopup(false); }}
                  style={{marginTop: '20px'}}
                >
                  {inscritoSimulado ? 'Inscrição Efetuada para o Próximo Simulado!' : 'Inscrever-se'}
                </button>
              </div>
              <button
                className="close-popup-statistics inscricao"
                onClick={() => setShowInscricaoPopup(false)}
              >
                X
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default StatisticsContent;
